const NAV_RAIL_EXPANDED_KEY = 'aleno_ops_nav_rail_expanded';

/** Default expanded on desktop; missing/invalid → true. */
export function loadNavRailExpanded(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    const raw = localStorage.getItem(NAV_RAIL_EXPANDED_KEY);
    if (raw === null) return true;
    return raw === '1' || raw === 'true';
  } catch {
    return true;
  }
}

export function saveNavRailExpanded(expanded: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(NAV_RAIL_EXPANDED_KEY, expanded ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
}
